<!-- Add card — inline Accept.js form. The saved-address picker feeds AVS
     server-side (createCard builds the billing address from addressId); the
     card fields are tokenized in the browser via Accept.dispatchData, so only
     the opaque nonce plus masked card metadata ever leaves the page.
     isFromRegistration renders the compact variant used inside the
     registration flow. -->
<section
    class="vb-payform"
    [class.vb-payform--registration]="isFromRegistration">
    <vb-panel-header
        *ngIf="!isFromRegistration"
        title="Add card"
        subtitle="We use your address to ensure your identity and protect against identity theft."></vb-panel-header>

    <h3 class="vb-payform__reg-title" *ngIf="isFromRegistration">
        Add payment method (optional)
    </h3>
    <p class="vb-payform__reg-note" *ngIf="isFromRegistration">
        We use your address to ensure your identity and protect against
        identity theft.
    </p>

    <div *ngIf="!isLoading" class="vb-payform__card">
        <vb-address-selection
            [userAddresses]="userAddresses"
            [defaultAddresses]="defaultAddresses"
            (selectedAddressEvent)="selectedShippingAddress = $event" />

        <div class="vb-payform__add-address">
            <ng-template #addAddrIcon>
                <vb-icon name="plus" [size]="14" [strokeWidth]="2"></vb-icon>
            </ng-template>
            <vb-button
                variant="ghost"
                size="sm"
                [iconLeft]="addAddrIcon"
                (clicked)="goToAddAddress()">
                Add new address
            </vb-button>
        </div>

        <form
            class="vb-payform__form"
            [formGroup]="cardForm"
            (ngSubmit)="onSubmit()">
            <h4 class="vb-payform__section-title">Card details</h4>

            <div class="vb-payform__grid">
                <div class="vb-payform__field">
                    <label class="vb-payform__label" for="firstName">
                        First name
                    </label>
                    <input
                        class="vb-payform__input"
                        name="firstName"
                        id="firstName"
                        type="text"
                        autocomplete="cc-given-name"
                        maxlength="50"
                        placeholder="First name on card..."
                        formControlName="firstName" />
                    <span
                        class="vb-payform__error"
                        *ngIf="getHelperText('firstName')">
                        {{ getHelperText("firstName") }}
                    </span>
                </div>
                <div class="vb-payform__field">
                    <label class="vb-payform__label" for="lastName">
                        Last name
                    </label>
                    <input
                        class="vb-payform__input"
                        name="lastName"
                        id="lastName"
                        type="text"
                        autocomplete="cc-family-name"
                        maxlength="50"
                        placeholder="Last name on card..."
                        formControlName="lastName" />
                    <span
                        class="vb-payform__error"
                        *ngIf="getHelperText('lastName')">
                        {{ getHelperText("lastName") }}
                    </span>
                </div>
            </div>

            <div class="vb-payform__field">
                <label class="vb-payform__label" for="cardNumber">
                    Card number
                </label>
                <span class="vb-payform__input-wrap">
                    <input
                        class="vb-payform__input vb-payform__input--mono"
                        name="cardNumber"
                        id="cardNumber"
                        type="text"
                        inputmode="numeric"
                        autocomplete="cc-number"
                        maxlength="19"
                        placeholder="XXXX XXXX XXXX XXXX"
                        formControlName="cardNumber"
                        (input)="onCardNumberInput($event)" />
                    <span class="vb-payform__brand" *ngIf="brandLabel">
                        {{ brandLabel }}
                    </span>
                </span>
                <span
                    class="vb-payform__error"
                    *ngIf="getHelperText('cardNumber')">
                    {{ getHelperText("cardNumber") }}
                </span>
            </div>

            <div class="vb-payform__grid">
                <div class="vb-payform__field">
                    <label class="vb-payform__label" for="expiry">
                        Expiry date
                    </label>
                    <input
                        class="vb-payform__input vb-payform__input--mono"
                        name="expiry"
                        id="expiry"
                        type="text"
                        inputmode="numeric"
                        autocomplete="cc-exp"
                        maxlength="5"
                        placeholder="MM/YY"
                        formControlName="expiry"
                        (input)="onExpiryInput($event)" />
                    <span
                        class="vb-payform__error"
                        *ngIf="getHelperText('expiry')">
                        {{ getHelperText("expiry") }}
                    </span>
                </div>
                <div class="vb-payform__field">
                    <label class="vb-payform__label" for="cvv">
                        Security code
                    </label>
                    <input
                        class="vb-payform__input vb-payform__input--mono"
                        name="cvv"
                        id="cvv"
                        type="text"
                        inputmode="numeric"
                        autocomplete="cc-csc"
                        maxlength="4"
                        placeholder="CVV"
                        formControlName="cvv"
                        (input)="onCvvInput($event)" />
                    <span
                        class="vb-payform__error"
                        *ngIf="getHelperText('cvv')">
                        {{ getHelperText("cvv") }}
                    </span>
                </div>
            </div>

            <div class="vb-payform__actions">
                <vb-button
                    *ngIf="!isFromRegistration"
                    variant="secondary"
                    (clicked)="goToCardList()">
                    Cancel
                </vb-button>
                <!-- type=submit routes clicks and Enter through ngSubmit;
                     no (clicked) binding needed. -->
                <vb-button
                    variant="primary"
                    type="submit"
                    [loading]="isSubmitting"
                    [disabled]="
                        cardForm.invalid ||
                        !selectedShippingAddress ||
                        isSubmitting
                    ">
                    Add payment method
                </vb-button>
            </div>
        </form>
    </div>

    <div class="vb-spinner-box vb-spinner-box--panel" *ngIf="isLoading">
        <vb-spinner size="xl" label="Loading"></vb-spinner>
    </div>
</section>
